export type ParsedSuccess<T> = { results: T; errors: []; hasErrors: false };
export type ParsedError = { results: undefined; errors: unknown[]; hasErrors: true };

export const parseToolCallResult = <T extends object>(
  results: string | undefined
): ParsedSuccess<T> | ParsedError | undefined => {
  if (!results) return undefined;

  try {
    const parsedResult = JSON.parse(results) as T;

    let errors: unknown[] = [];
    if ('errors' in parsedResult) {
      if (Array.isArray(parsedResult.errors)) {
        errors = parsedResult.errors as unknown[];
      } else {
        errors = [parsedResult.errors as unknown];
      }
    }

    const hasErrors = errors.length > 0;

    if (hasErrors) {
      return {
        results: undefined,
        errors,
        hasErrors: true,
      };
    }

    return {
      results: parsedResult,
      errors: [],
      hasErrors: false,
    };
  } catch (error) {
    console.error('Error parsing result', error);

    if (results.trim().startsWith('Error:')) {
      return {
        results: undefined,
        errors: [results.trim().split('Error:')[1].trim()],
        hasErrors: true,
      };
    }

    return {
      results: undefined,
      errors: [(error as Error).toString()],
      hasErrors: true,
    };
  }
};
